import { useEffect, useState } from 'react';
import { toast } from '../../../../core/components/atoms/Toast';
import { deckService } from '../../queries';
import useUserMemory from '../use-user-memory';

const useDecks = () => {
  const { memoryUserUuid } = useUserMemory();
  const userUuid = memoryUserUuid;

  const [decks, setDecks] = useState<Deck[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDecks = async () => {
    if (!userUuid) return;
    try {
      setIsLoading(true);
      const decks = await deckService.list(userUuid);
      setDecks(decks);
    } catch (error) {
      console.error(error);
      toast({
        title: 'Erro ao buscar decks',
        message: 'Tente novamente mais tarde',
        variant: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDecks();
  }, [userUuid]);

  return {
    decks,
    fetchDecks,
    isLoading,
  };
};

export default useDecks;
